import { render, staticRenderFns } from "./HeaderLastDocuments.vue?vue&type=template&id=7bf92bce&scoped=true"
import script from "./HeaderLastDocuments.vue?vue&type=script&lang=js"
export * from "./HeaderLastDocuments.vue?vue&type=script&lang=js"
import style0 from "./HeaderLastDocuments.vue?vue&type=style&index=0&id=7bf92bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf92bce",
  null
  
)

export default component.exports